import { useSelector } from 'react-redux';

import { currentOpenChatSelector } from '../../../selectors';
import { TPendingBlobFile } from '../../../types/file';
import { TDocumentFile } from '../../../types/messageFiles';
import { TOpenedChat } from '../../../types/openedChats';

export const useDocument = (
  messageId: string,
  document?: TDocumentFile,
): { documentDraft: TPendingBlobFile | null; document: TDocumentFile | null } => {
  const currentChat = useSelector(currentOpenChatSelector);
  const { pendingFiles } = currentChat || ({} as TOpenedChat);

  const blobFiles = pendingFiles?.[messageId]?.blobFiles || [];
  const documentBlobFiles = blobFiles.filter(({ type }) => type === 'document');

  if (document) {
    return { documentDraft: null, document };
  }

  if (documentBlobFiles.length) {
    return { documentDraft: documentBlobFiles[0], document: null };
  }

  return { documentDraft: null, document: null };
};
